import '../../blocks/articles-slider/articles-slider.js';
import '../../blocks/cases-slider/cases-slider.js';

const publicationBlok = document.querySelector('.publication-block');

window.addEventListener('load', ()=>{
    showMore();
});

window.addEventListener('resize', ()=>{
    showMore();
});

function showMore() {
    if (publicationBlok) {
        const publications = publicationBlok.querySelectorAll('.publication');
        const button = publicationBlok.querySelector('.publication-show-more');
        let step = 3;
        
        if (window.innerWidth <= 992) {
            step = 2;
        }        
        if (window.innerWidth <= 650) {
            step = 1;
        }

        button.addEventListener('click', ()=>{
            for (let index = 0; index < step; index++) {
                const element = publications[index];
                element.classList.add('show');
            }

            for (let index = 0; index < publications.length; index++) {
                const element = publications[index];

                if (!element.classList.contains('show')) {
                    for (let j = index; j < index + step; j++) {
                        const element = publications[j];
                        if (element) {
                            element.classList.add('show');                            
                        }
                    }
                    if (!publications[index + step]) {
                        button.classList.add('hidden');
                    }
                    index = publications.length + 1;
                }
            }
        });
    }
}